import { RouteFn } from '@/hooks/use-flow';
import { useAction } from '@/hooks/use-action';
import { BindContext } from '../../contexts/bind/bind-context';
import { Form } from '@/hooks/use-form-field';
import { BindForm as BindFormSchema } from '@/schemas/sceneDataSchema';
import { DynamicRenderer } from '@/components/DynamicUI/DynamicRenderer';
import useDynamicForm from '@/hooks/use-dynamic-form';

interface BindProviderProps {
  formData: BindFormSchema;
  route: RouteFn;
}

export function BindForm({ formData, route }: BindProviderProps) {
  const { submitAsync, isLoading } = useAction();
  const form = useDynamicForm(formData.components);

  async function submitBind(): Promise<void> {
    const valid = await form.trigger();
    if (!valid) return;
    if (isLoading) return;

    const data = {
      ...form.getValues(),
    };

    await submitAsync(formData.action_name, data, route);
  }

  return (
    <BindContext value={{ submitBind }}>
      <Form {...form}>
        <DynamicRenderer
          form={form}
          components={formData.components}
          route={route}
          submit={() => {}}
        />
      </Form>
    </BindContext>
  );
}
